import type { Locale } from "@/i18n/types";
import type { Messages } from "@/i18n/locales/en";
import { enMessages } from "@/i18n/locales/en";
import { ruMessages } from "@/i18n/locales/ru";
import { lvMessages } from "@/i18n/locales/lv";
import { esMessages } from "@/i18n/locales/es";
import { deMessages } from "@/i18n/locales/de";
import { frMessages } from "@/i18n/locales/fr";
import { plMessages } from "@/i18n/locales/pl";
import { itMessages } from "@/i18n/locales/it";
import { ptMessages } from "@/i18n/locales/pt";
import { nlMessages } from "@/i18n/locales/nl";
import { csMessages } from "@/i18n/locales/cs";
import { ukMessages } from "@/i18n/locales/uk";
import { trMessages } from "@/i18n/locales/tr";
import { roMessages } from "@/i18n/locales/ro";
import { huMessages } from "@/i18n/locales/hu";
import { svMessages } from "@/i18n/locales/sv";
import { fiMessages } from "@/i18n/locales/fi";
import { nbMessages } from "@/i18n/locales/nb";
import { daMessages } from "@/i18n/locales/da";
import { ltMessages } from "@/i18n/locales/lt";
import { etMessages } from "@/i18n/locales/et";
import { skMessages } from "@/i18n/locales/sk";
import { hrMessages } from "@/i18n/locales/hr";
import { slMessages } from "@/i18n/locales/sl";

export const messagesByLocale = {
  en: enMessages,
  ru: ruMessages,
  lv: lvMessages,
  es: esMessages,
  de: deMessages,
  fr: frMessages,
  pl: plMessages,
  it: itMessages,
  pt: ptMessages,
  nl: nlMessages,
  cs: csMessages,
  uk: ukMessages,
  tr: trMessages,
  ro: roMessages,
  hu: huMessages,
  sv: svMessages,
  fi: fiMessages,
  nb: nbMessages,
  da: daMessages,
  lt: ltMessages,
  et: etMessages,
  sk: skMessages,
  hr: hrMessages,
  sl: slMessages,
} satisfies Record<Locale, Messages>;
